import { Link } from "@mui/material";
import { openAuthedResource } from "../../utils/authedResource";
import { useNotification } from "../../hooks";

const AuthedFileLink = ({
  url,
  filename = "download",
  children,
  fallback = "-",
  onError,
  ...linkProps
}) => {
  const notify = useNotification();

  if (!url) return fallback;

  const handleClick = (event) => {
    event.preventDefault();

    event.stopPropagation();
    openAuthedResource(url, { filename }).catch((error) => {
      const message = error.message || "Failed to open the file.";
      if (onError) onError(message);
      else notify(message, "error");
    });
  };

  return (
    <Link
      component="button"
      type="button"
      onClick={handleClick}
      underline="hover"
      color="primary"
      {...linkProps}
      sx={{ textAlign: "left", verticalAlign: "baseline", ...linkProps.sx }}
    >
      {children}
    </Link>
  );
};

export default AuthedFileLink;
